import React, {Component} from 'react'
import {Icon} from 'semantic-ui-react'
import {formatDate} from '../cads/format-date'
import {unminifyAccountName} from '../cads/unminify'

const borderColor = 'rgb(228,203,131)'
const labelStyle = {width: '135px', display: 'inline-block'}

class FoundPoNumberBox extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    let {data} = this.props

    return (
      <React.Fragment>
        <div style={{background: 'rgb(19,28,45)', color: 'white', border: '2px solid '+borderColor, float: 'right', borderRadius: '10px', width: '400px'}}>
          <div style={{padding: '10px 20px'}}>
            <h2 style={{display: 'inline-block', marginTop: 0, width: '80%'}}><Icon name='file' style={{color: borderColor}}/> &nbsp; <span style={{borderBottom: '1px solid '+borderColor, display: 'inline-block', width: '100%', paddingBottom: '10px'}}>PO # found</span></h2>
          </div>
          <div style={{padding: '10px 20px', paddingTop: 0, lineHeight: '2em'}}>
            <span style={labelStyle}><Icon name='file' style={{color: borderColor}}/> PO #:</span>{!!data.shipped ? data.p : data.ponumber}<br/>
            <span style={labelStyle}><Icon name='user' style={{color: borderColor}}/> Account Name:</span>{!!data.shipped ? unminifyAccountName(data.a) : data.account_name}<br/>
            <span style={labelStyle}><Icon name='cube' style={{color: borderColor}}/> Order Type:</span>{!!data.shipped ? 'SHIPPED' : ''}{!data.shipped && !data.hold && !data.worksheet && !data.pending_po ? 'PO' : ''}{!!data.hold ? 'Hold' : ''}{!!data.worksheet ? 'Worksheet' : ''}{!!data.pending_po ? 'Pending PO' : ''}<br/>
            <span style={labelStyle}><Icon name='calendar' style={{color: borderColor}}/> Start Ship:</span>{formatDate(!!data.shipped ? data.d : data.date)}<br/>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default FoundPoNumberBox
